export default __webpack_public_path__ + "static/media/survey.f7b47dd5.png";